import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import { isEmpty } from 'lodash';
import { useWindowSize } from 'react-use';
import { useNextStyleRouter } from '../../hooks/useNextStyleRouter';
import NCRDesktopSliderForm from '../leads/LeadForm/SliderForm/SliderForm';
import NewModalOverlay from '../components/modal/NewModalOverlay';
import EnquiryForm from '../venues/components/EnquiryForm';
import formStyles from '../LeadForm/embeddedleadForm.module.css';
import getquotestyles from '../LeadForm/getquote.module.css';
import {
  CORPORATE_EVENT_VENUE_HEADING,
  CORPORATE_EVENT_VENUE_SUBHEADING,
  Corporatecontent,
  Corporatesteps,
  GET_STARTED_TEXT,
  CORPORATE_OFFERING_SEGMENT_TITLE,
} from '../../constants/LandlingPageStandalones/faridabad_banquet_standalone_constants';
import { setEnquiryFormVisible, setEnquiryFormVisibleState } from '../../redux/actions/LeadFormActions';
import { MODELS, VENUE_CORPORATE_STANALONE, VENUE_CORPORATE_STANALONE_GURGAON } from '../../constants/constants';
import { getSelectedEvent } from '../../redux/selectors/EventSelectors';
import { recordPageLoad } from '../../util/vmTrackingHandler';
import { getCurrentSelectedCityPage } from '../../redux/actions/LeadActions';
import { setUserCity } from '../../redux/actions/HeaderActions';
import { getEnquiryFormBtnText } from '../../util/leadFormUtility';
import { CORPORATE_EVENT_VENUE_ASSISTANCE } from '../../constants/enquiryFormConst';
import { DO_YOU_NEED_ASSISTANCE_CALL } from '../../constants/HaveUsCallYouBannerConst';
import { getEnquiryFormVisibilityState } from '../../redux/selectors/LeadFormSelectors';
import { corporateclienticon, CORPORATE_HERO_STATIC_BG_URL } from '../../constants/leadFormConstants';
import CorporateLandingTile from './CorporateLandingTile';

const clientCarouselSettings = {
  lazyLoad: true,
  infinite: true,
  autoplaySpeed: 1500,
  autoplay: true,
  pauseOnFocus: true,
  speed: 500,
  centerMode: true,
  centerPadding: '98px',
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplaySpeed: 1500,
        autoplay: true,
        dots: false,
      },
    },
  ],
};

function CorporateLeadForm() {
  const router = useNextStyleRouter();
  const dispatch = useDispatch();
  const { width } = useWindowSize();
  const event = useSelector((state) => getSelectedEvent(state));
  const isEnquiryFormVisible = useSelector((state) => getEnquiryFormVisibilityState(state));
  const currentUrl = router.asPath;

  useEffect(() => {
    recordPageLoad('page', 'EBDP', 'EBDP', currentUrl, '');
  }, [dispatch, currentUrl]);

  const closeEnquiryOverlay = () => {
    dispatch(setEnquiryFormVisibleState(false));
  };

  const onNeedAssistenceClick = () => {
    dispatch(
      setEnquiryFormVisible({
        pageType: 'corporate-lp',
        formType: CORPORATE_EVENT_VENUE_ASSISTANCE,
        btnSource: 'corporate_venues_have_us_call_you_form',
        leadType: MODELS[VENUE_CORPORATE_STANALONE].lead_type,
      })
    );
  };

  const getLeadform = () => (
    <div className={formStyles['form-container-wrapper']}>
      <div className={formStyles['form-sub-container']}>
        <NCRDesktopSliderForm
          leadFormMode={VENUE_CORPORATE_STANALONE}
          router={router}
          pageSource="corporate-lp"
          embeddedLpStyle="get-quote"
        />
      </div>
    </div>
  );

  const isFormOnlyLayout = typeof width === 'number' && width <= 768;

  const clientsSection = (
    <section className={getquotestyles['gq-features']}>
      <h2 className={getquotestyles['gq-features-title']}>Our clients</h2>
      <div className={getquotestyles['Corporate-clients-container']}>
        <Slider {...clientCarouselSettings}>
          {corporateclienticon.map((image) => (
            <div key={image.id}>
              <img
                src={image.icon}
                alt=""
                className={getquotestyles['corporate-client-images']}
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );

  const offeringsSection = (
    <div className={getquotestyles['corporate-offering-section-container']}>
      <h2 className={getquotestyles['gq-features-title']}>{CORPORATE_OFFERING_SEGMENT_TITLE}</h2>
      <div className={getquotestyles['corporate-card-section-container']}>
        {Corporatecontent.map((corporate) => (
          <CorporateLandingTile
            key={corporate.heading}
            heading={corporate.heading}
            subheading={corporate.subheading}
            content={corporate.content}
          />
        ))}
      </div>
    </div>
  );

  const stepsSection = (
    <section className={getquotestyles['gq-features']}>
      <h2 className={getquotestyles['gq-features-title']}>{GET_STARTED_TEXT}</h2>
      <div className={getquotestyles.card}>
        {Corporatesteps.map((card, index) => (
          <div key={card.heading} className={getquotestyles['discover-container']}>
            <div className={getquotestyles['gq-corporate-step-badge']}>
              <p className={getquotestyles['corporate-card-number-text']}>{index + 1}</p>
            </div>
            <p className={getquotestyles['discover-heading']}>{card.heading}</p>
            <p className={getquotestyles['discover-desc']}>{card.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );

  const assistanceSection = isEmpty(event) ? (
    <section className={getquotestyles['gq-assist']}>
      <div className={getquotestyles['gq-assist-inner']}>
        <div className={getquotestyles['gq-assist-copy']}>
          <p className={getquotestyles['gq-assist-line']}>
            Do you need <span className={getquotestyles['gq-assist-accent']}>assistance?</span>
          </p>
          <p className={getquotestyles['gq-assist-meta']}>Get in touch with an expert</p>
          <p className={getquotestyles['gq-assist-phone']}>{DO_YOU_NEED_ASSISTANCE_CALL}</p>
        </div>
        <button
          type="button"
          className={getquotestyles['gq-assist-btn']}
          onClick={onNeedAssistenceClick}
        >
          {getEnquiryFormBtnText(CORPORATE_EVENT_VENUE_ASSISTANCE)}
        </button>
      </div>
    </section>
  ) : null;

  const desktopHero = (
    <section className={getquotestyles['gq-hero']}>
      <div
        className={getquotestyles['gq-corporate-hero-static-bg']}
        style={{ backgroundImage: `url(${CORPORATE_HERO_STATIC_BG_URL})` }}
        aria-hidden
      />
      <div className={getquotestyles['gq-hero-overlay']} aria-hidden />
      <div className={getquotestyles['gq-hero-inner']}>
        <div className={getquotestyles['gq-hero-copy']}>
          <div className={getquotestyles['banner-container']}>
            <div className={getquotestyles['banner-text-container']}>
              <p className={getquotestyles['get-quote-header']}>{CORPORATE_EVENT_VENUE_HEADING}</p>
              <p className={getquotestyles['get-quote-subheading']}>
                {CORPORATE_EVENT_VENUE_SUBHEADING}
              </p>
            </div>
          </div>
        </div>
        <div className={getquotestyles['gq-hero-form']}>{getLeadform()}</div>
      </div>
    </section>
  );

  return (
    <>
      <div className={getquotestyles['get-quote-lp']}>
        {isFormOnlyLayout ? (
          <>
            <div className={getquotestyles.gqMobileFormOnly}>{getLeadform()}</div>
            {clientsSection}
            {offeringsSection}
            {stepsSection}
            {assistanceSection}
          </>
        ) : (
          <>
            {desktopHero}
            {clientsSection}
            {offeringsSection}
            {stepsSection}
            {assistanceSection}
          </>
        )}
      </div>
      {isEnquiryFormVisible ? (
        <NewModalOverlay
          isOverlayOpen={isEnquiryFormVisible}
          closeOverlay={closeEnquiryOverlay}
          width={width > 768 ? '400px' : '100%'}
          height={width > 768 ? '600px' : '100%'}
          borderRadius="8px"
          padding="16px"
        >
          <EnquiryForm />
        </NewModalOverlay>
      ) : null}
    </>
  );
}

export default CorporateLeadForm;
